// extracted by mini-css-extract-plugin
export default {"root":"TabNav_root__gjNfb","tab":"TabNav_tab__eA3Af","link":"TabNav_link__PL7ZZ","selectedLink":"TabNav_selectedLink__l6az3","disabled":"TabNav_disabled__11EDF"};